import { Award } from "lucide-react";

export default function HireBadge({ count = 0, className = "" }) {
  if (!count || count < 1) return null;
  return (
    <span
      data-testid="hire-badge"
      title={`${count} hired via African Bridge Media`}
      className={`inline-flex items-center gap-1 rounded-full text-xs font-medium px-2.5 py-1 bg-[#1E3A2F] text-[#DDA74A] ${className}`}
    >
      <Award className="w-3.5 h-3.5" />
      <span>{count} hired via ABM</span>
    </span>
  );
}
